export default [
  {
    path: window.pathApp + '/controle-de-contribuicao',
    name: 'controle.contribuicao',
    component: () => import('@/components/ControleContribuicao'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: 'Controle de Contribuição',
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/controle_contribuicao.js